import { Typography } from "@mui/material";
import moment from "moment";
import { BentoBrand } from "schemas/dashboard";

interface Props {
  bentoBrand: BentoBrand;
}

const DateOrEmail = ({ bentoBrand }: Props) => {
  if (bentoBrand?.earliestPendingSendAt) {
    return (
      <>
        <Typography variant="body2" sx={{ mt: 1 }}>
          Scheduled for{" "}
          <strong>
            <em>
              {" "}
              {moment(bentoBrand?.earliestPendingSendAt).format("MMM DD, YYYY")}
            </em>
          </strong>
        </Typography>
      </>
    );
  } else if (bentoBrand?.latestEmailCompletedAt) {
    return (
      <Typography variant="body2" sx={{ mt: 1 }}>
        Emailed on{" "}
        <strong>
          <em>
            {" "}
            {moment(bentoBrand?.latestEmailCompletedAt).format("MMM DD, YYYY")}
          </em>
        </strong>
      </Typography>
    );
  } else {
    return <></>;
  }
};

export default DateOrEmail;
